exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.list-group-item[data-v-10371afb]{padding:0}.like__icon[data-v-10371afb]:hover{transform:scale(1.2);transition:all .1s ease-in-out}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-10371afb","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/BlogView.vue
// module id = 639
// module chunks = 0